import { EMPTY, fromEvent, Observable, of, throwError } from 'rxjs';
import { filter, map, switchMap, timeout } from 'rxjs/operators';

import { firstValueFrom } from 'rev-shared/rxjs/firstValueFrom';
import { ISDKPostMessage, TSDKMessage } from '../embed/ISDKContracts';

export const parentMessages$:Observable<ISDKPostMessage> = fromEvent<MessageEvent>(window, 'message').pipe(
	map(e => e.data || {}),
	filter(data => data.app === 'vbrick' && data.event)
);

export function awaitParentMessage<T = any>(event: string, failEvent?: string, timeoutMs: number = 30000): Promise<ISDKPostMessage<T>> {
	return firstValueFrom(parentMessages$.pipe(
		switchMap(data => {
			switch(data.event) {
				case event: return of(data);
				case failEvent: return throwError(`Await Event failed: ${failEvent}`);
			}
			return EMPTY;
		}),
		timeout(timeoutMs)
	));
}

export function publishParentMessage(...[event, msg = undefined]: TSDKMessage): void {
	const parent = global.parent;
	const targetWin = parent && parent !== window ? parent : window.opener;
	if(!targetWin) {
		return;
	}
	if(!event) {
		throw new Error('postMessage missing event');
	}

	targetWin.postMessage({
		app: 'vbrick',
		event,
		msg
	}, '*');
}
